<template>
  <div class="assessment">
    <div class="title">{{ $tr('vacancy.settings.talentq.project-block-title') }}</div>
    <vbutton
      class="remove-button"
      color="transparent"
      type="icon"
      icon="icon-bin"
      @click="$emit('remove')"/>
    <div class="field flex">
      <span>{{ $tr('vacancy.settings.talentq.project-accept-level') }}</span>
      <vinput
        class="small-input"
        :value="assessment.accept_level"
        :valuetype="'number'"
        :center="true"
        @input="$emit('set_key_value', {key: 'accept_level', value: $event})"/>
    </div>
    <slot/>
  </div>
</template>
<script>
  export default {
    name: "project-assessment-view",
    props: {
      assessment: {
        type: Object,
        required: true,
      }
    }
  }
</script>
<style scoped lang="scss">
  .assessment {
    position: relative;
    .title {
      margin: 20px 0 15px;
      padding-right: 40px; // Размер кнопки удаления
      font-size: 17px;
      font-weight: 300;
    }

    .field {
      margin: 10px 0;
    }

    .flex {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .small-input {
      max-width: 60px;
      min-width: 60px;
    }
    .remove-button {
      position: absolute;
      right: 0;
      top: -10px;
    }
  }
</style>